const ErrorModal = ({ message, onClose }) => {
  return (
    <>
      <div className="select-error-wrap">
        <div className="popup">
          <div
            className="title-error"
            dangerouslySetInnerHTML={{ __html: message }}
            style={{ whiteSpace: 'pre-line' }}
          />
          <div className="button select-error-btn" onClick={() => onClose()}>
            <ul>
              <li>OK</li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorModal;
